<div class="schedule-page" [class.is-success]="success" [class.is-status]="loading || (!!error && !success) || success">
  <div class="schedule-card" *ngIf="loading">
    <div class="pulse"></div>
    <p>Cargando calendario...</p>
  </div>

  <div class="schedule-card error" *ngIf="!loading && error && !success">
    <h1>No se pudo abrir la agenda</h1>
    <p>{{ error }}</p>
  </div>

  <div class="schedule-card success" *ngIf="success">
    <h1>¡Listo!</h1>
    <p>Tu visita quedó agendada correctamente.</p>
    <button type="button" class="btn-secondary" (click)="reopenSchedule()">
      Ver / reprogramar
    </button>
  </div>

  <ng-container *ngIf="!loading && !error && !success">
    <div class="schedule-hero">
      <p class="eyebrow">Agenda de visitas</p>
      <h1>Hola{{ clientName ? ', ' + clientName : '' }}</h1>
      <p class="lead">
        Verificá la dirección, indicá quién nos recibe y elegí día y franja.
      </p>
      <p class="lead address-note">
        Si el equipo <strong>no está en esa dirección</strong>, escribinos por
        <a
          href="https://wa.me/5491168786533?text=Hola,%20necesito%20gestionar%20un%20cambio%20de%20dirección%20para%20agendar%20una%20visita"
          target="_blank"
          rel="noopener noreferrer"
        >WhatsApp</a>
        para hacer el cambio de domicilio y la gestión interna. Podés ajustar el marcador un poco para marcar el punto exacto, pero no lo muevas lejos: eso ya implica un cambio de dirección.
      </p>
    </div>

    <div class="debt-banner" *ngIf="hasDebt">
      <strong>Tenés deuda pendiente</strong>
      <span>No podés agendar hasta regularizar el saldo ({{ debt | number: '1.2-2' }}).</span>
    </div>

    <div class="info-banner" *ngIf="!hasDebt && activeBooking && canModifyVisit">
      <strong>Podés modificar esta visita</strong>
      <span>
        Cancelar, reprogramar o editar contacto/ubicación hasta el
        {{
          (activeBooking.modifiable_until ||
            activeBooking.cancellable_until ||
            activeBooking.editable_until) | date: 'dd/MM/yyyy'
        }}
        (días hábiles; no contamos sábados, domingos ni feriados).
      </span>
    </div>

    <div class="warn-banner" *ngIf="!hasDebt && isVisitLocked">
      <strong>Visita ruteada</strong>
      <span>
        A partir del día hábil previo a
        {{ activeBooking.scheduled_date | date: 'dd/MM/yyyy' }}
        el recorrido ya está armado. No se puede cancelar, reprogramar ni editar.
        Si necesitás ayuda, escribinos por WhatsApp.
      </span>
    </div>

    <div class="schedule-grid" [class.blocked]="hasDebt || isVisitLocked">
      <section class="panel">
        <h2>1. Máquina</h2>
        <div *ngIf="subscriptions.length === 0" class="empty">
          No hay mantenimientos ni filtros pendientes.
        </div>
        <button
          type="button"
          class="machine"
          *ngFor="let sub of subscriptions"
          [class.active]="selectedSubscriptionId === sub.subscription_id"
          [class.disabled]="!sub.can_book && !sub.active_booking"
          [disabled]="(!sub.can_book && !sub.active_booking) || hasDebt"
          (click)="onSubscriptionChange(sub.subscription_id)"
        >
          <div class="machine-title">
            {{ sub.product_name }}
            <span *ngIf="sub.unit_serial">· N° {{ sub.unit_serial }}</span>
          </div>
          <div class="machine-meta">
            Vence {{ sub.due_date | date: 'dd/MM/yyyy' }}
            <span *ngIf="!sub.can_book && !sub.active_booking"> · disponible desde {{ sub.available_from | date: 'dd/MM/yyyy' }}</span>
          </div>
          <div class="tags">
            <span *ngIf="sub.has_maintenance">Mantenimiento</span>
            <span *ngIf="sub.has_filters">Filtros</span>
            <span *ngIf="sub.active_booking" class="booked">
              Ya agendada {{ sub.active_booking.scheduled_date | date: 'dd/MM' }} {{ sub.active_booking.slot }}
            </span>
          </div>
        </button>

        <h2 class="mt">2. Quién nos recibe</h2>
        <label class="field-label">Nombre de la persona *</label>
        <input
          type="text"
          [(ngModel)]="receiverName"
          [disabled]="!canEditContactAndMap"
          required
          placeholder="Ej: Juan Pérez"
          class="field"
        />
        <label class="field-label">Teléfono de contacto *</label>
        <input
          type="tel"
          [(ngModel)]="receiverPhone"
          [disabled]="!canEditContactAndMap"
          required
          placeholder="Ej: 11 5555-5555"
          class="field"
        />
        <p class="hint" *ngIf="canEditContactAndMap && (!receiverName?.trim() || !receiverPhone?.trim())">
          Completá nombre y teléfono para poder confirmar.
        </p>
      </section>

      <section class="panel">
        <h2>3. Verificá la dirección</h2>
        <p class="hint top">
          Ajustá el marcador solo si hace falta para marcar el punto exacto del equipo.
          Si el domicilio es otro, no lo arrastres lejos: pedí el cambio de dirección por WhatsApp.
        </p>
        <div class="address-line" *ngIf="verifiedAddress">{{ verifiedAddress }}</div>
        <div #mapContainer class="map-box"></div>
        <p class="coords" *ngIf="mapReady">
          Lat {{ lat | number: '1.5-5' }} · Lng {{ lng | number: '1.5-5' }}
        </p>

        <div class="cal-header">
          <h2>4. Día</h2>
          <div class="nav">
            <button type="button" (click)="prevMonth()" [disabled]="hasDebt || isVisitLocked">‹</button>
            <span>{{ monthLabel }}</span>
            <button type="button" (click)="nextMonth()" [disabled]="hasDebt || isVisitLocked">›</button>
          </div>
        </div>

        <div class="weekdays">
          <span>Dom</span><span>Lun</span><span>Mar</span><span>Mié</span><span>Jue</span><span>Vie</span><span>Sáb</span>
        </div>
        <div class="days">
          <button
            type="button"
            *ngFor="let cell of monthCells"
            class="day"
            [class.empty]="!cell.inMonth"
            [class.disabled]="!cell.meta || cell.meta.disabled || hasDebt || isVisitLocked"
            [class.full]="cell.meta?.reason === 'full'"
            [class.selected]="selectedDate === cell.date"
            [disabled]="!cell.inMonth || !cell.meta || cell.meta.disabled || hasDebt || isVisitLocked"
            (click)="selectDate(cell)"
          >
            <span *ngIf="cell.inMonth">{{ cell.day }}</span>
          </button>
        </div>
      </section>

      <section class="panel">
        <h2>5. Franja</h2>
        <div *ngIf="!selectedDate" class="empty">Elegí un día disponible</div>
        <div class="slots" *ngIf="selectedDate">
          <button
            type="button"
            *ngFor="let slot of availableSlots"
            class="slot"
            [class.active]="selectedSlot === slot"
            [disabled]="hasDebt || isVisitLocked"
            (click)="selectSlot(slot)"
          >
            {{ slot }} hs
          </button>
          <div *ngIf="availableSlots.length === 0" class="empty">
            Sin franjas para ese día
          </div>
        </div>

        <div class="summary" *ngIf="selectedDate && selectedSlot">
          <div><strong>Día:</strong> {{ selectedDate | date: 'dd/MM/yyyy' }}</div>
          <div><strong>Franja:</strong> {{ selectedSlot }}</div>
          <div><strong>Recibe:</strong> {{ receiverName || '—' }}</div>
          <div><strong>Tel:</strong> {{ receiverPhone || '—' }}</div>
        </div>

        <p
          class="form-error"
          *ngIf="formError || (isVisitLocked && confirmBlockedReason()) || ((selectedDate && selectedSlot) && confirmBlockedReason())"
        >
          {{ formError || confirmBlockedReason() }}
        </p>

        <button
          type="button"
          class="btn-primary"
          *ngIf="!isVisitLocked"
          [disabled]="!!confirmBlockedReason()"
          (click)="confirm()"
        >
          {{ confirmButtonLabel }}
        </button>
        <button
          type="button"
          class="btn-danger"
          *ngIf="canCancelVisit"
          [disabled]="cancelling || submitting"
          (click)="cancelVisit()"
        >
          {{ cancelling ? 'Cancelando...' : 'Cancelar visita' }}
        </button>
        <p class="hint">
          Mínimo 48 hs hábiles. Con 72 hs podés elegir franjas parciales.
          Cancelar, reprogramar o editar: hasta 2 días hábiles antes
          (el día hábil previo ya está ruteado). No se agenda en feriados.
        </p>
      </section>
    </div>
  </ng-container>
</div>
